const initialState = {
  selectedLanguage: 'es'
}

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
  case 'SET_LANGUAGE':
    return {
      ...state,
      selectedLanguage: action.language
    }
  default:
    return state
  }
}

export default languageReducer



// WEBPACK FOOTER //
// ./src/redux/Reducers/languageReducer.js